import type { ReactNode } from 'react';
import type { UnitVehicle } from '../units.paths';

interface VehicleSectionProps {
  vehicleKind: UnitVehicle;
  registration: string;
  actions?: ReactNode;
  children: ReactNode;
}

/** One vehicle's part of a unit tab, headed with which vehicle it is, so the truck's and the trailer's never read as one record. */
export function VehicleSection({ vehicleKind, registration, actions, children }: VehicleSectionProps) {
  const noun = vehicleKind === 'truck' ? 'Truck' : 'Trailer';
  return (
    <section className="flex min-w-0 flex-col gap-3" aria-label={`${noun} ${registration}`}>
      <header className="flex flex-wrap items-center justify-between gap-2 border-b border-line pb-2">
        <h3 className="m-0 flex items-baseline gap-2 text-sm font-semibold">
          <span className="text-xs tracking-wider text-muted uppercase">{noun}</span>
          <span className="font-mono">{registration}</span>
        </h3>
        {actions}
      </header>
      {children}
    </section>
  );
}
